/* ==========================================================================
   POESPAS — Kortingsacties   (Claude, 09-10-2026)

   Hoort bij sections/kortingsacties.liquid. Die sectie staat in de thema-editor
   onder Overlay; elk blok daar is één actie en komt hier binnen als instelling.
   Er staat dus NIETS hardcoded in dit bestand: product, bedrag en teksten
   beheer je in de editor.

   BLOK "GRATIS CADEAU"
     klant voldoet aan de voorwaarde  -> cadeau gaat er vanzelf in
     klant voldoet niet meer          -> cadeau gaat er vanzelf uit
     klant haalt het cadeau zelf weg  -> we leggen het niet opnieuw terug
   De voorwaarde kies je in het blok: een aankoopbedrag, bepaalde producten of
   een collectie (dan 1 cadeau per bestelling of 1 per gekocht artikel).

   DE KORTING ZIT HIER NIET IN.
   De €0 komt uit de automatische Shopify-korting (Koop X krijg Y). Na het
   toevoegen kijken we of het cadeau echt gratis is geworden. Zo niet (korting
   staat uit, of een andere actie wint), dan halen we het weer weg: een klant
   krijgt nooit ongevraagd een betaald artikel in de mand.
   ========================================================================== */
(function () {
  'use strict';

  var CADEAU_PROP = '_pp_cadeau';   // underscore = onzichtbaar voor de klant

  // In de thema-editor wordt dit bestand bij elke wijziging opnieuw geladen. Er mag
  // maar één exemplaar draaien, anders vechten oude en nieuwe instellingen om de
  // melding. Het bestaande exemplaar leest dan gewoon de nieuwe instellingen in.
  if (window.__ppKortingsacties) { window.__ppKortingsacties.herlaad(); return; }

  var ACTIES = leesActies();

  var bezig = false;
  var wachtrij = false;
  var laatsteStand = {};   // actie-id -> { rest, behaald } voor de melding

  function leesActies() {
    var el = document.querySelector('[data-pp-kortingsacties]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent).filter(function (a) { return a.type === 'gratis_cadeau'; });
    } catch (e) { return []; }
  }

  /* ---------- geheugen per bezoek ----------
     'in'       cadeau lag in de mand
     'nee'      klant heeft het zelf weggehaald
     'blok:N'   bij mandbedrag N lukte het niet (voorraad op of niet gratis) */

  function onthoud(actie, waarde) {
    try {
      if (waarde) sessionStorage.setItem('pp-ka-' + actie.id, waarde);
      else sessionStorage.removeItem('pp-ka-' + actie.id);
    } catch (e) {}
  }

  function herinner(actie) {
    try { return sessionStorage.getItem('pp-ka-' + actie.id) || ''; } catch (e) { return ''; }
  }

  /* ---------- mand ---------- */

  function haalMand() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function voegCadeauToe(actie, aantal) {
    var props = {};
    props[CADEAU_PROP] = actie.id;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: actie.variantId, quantity: aantal, properties: props }] })
    }).then(function (r) { return r.json(); });
  }

  function zetAantal(lineKey, aantal) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: aantal })
    }).then(function (r) { return r.json(); });
  }

  function cadeauRegels(mand, actie) {
    return (mand.items || []).filter(function (i) {
      return i.properties && i.properties[CADEAU_PROP] === actie.id;
    });
  }

  function aantalIn(regels) {
    return regels.reduce(function (n, i) { return n + i.quantity; }, 0);
  }

  function gratisIn(regels) {
    return regels.reduce(function (n, i) { return i.final_line_price === 0 ? n + i.quantity : n; }, 0);
  }

  // Waar de drempel op telt: het eindbedrag van de mand (ná korting, zonder
  // verzending), zonder het cadeau zelf en standaard zonder cadeaubonnen.
  function telBedrag(mand, actie) {
    var bedrag = mand.total_price || 0;
    (mand.items || []).forEach(function (i) {
      var isCadeau = i.properties && i.properties[CADEAU_PROP] === actie.id;
      if (isCadeau || (i.gift_card && !actie.cadeaubonnenTellenMee)) bedrag -= i.final_line_price;
    });
    return bedrag;
  }

  // Hoeveel gekochte artikelen tellen mee (het cadeau zelf nooit).
  function telArtikelen(mand, actie) {
    var ids = actie.productIds || [];
    return (mand.items || []).reduce(function (n, i) {
      var isCadeau = i.properties && i.properties[CADEAU_PROP] === actie.id;
      return (!isCadeau && ids.indexOf(i.product_id) !== -1) ? n + i.quantity : n;
    }, 0);
  }

  // Hoeveel cadeaus horen er nu in de mand? 'sleutel' beschrijft de stand van
  // de mand, zodat we een mislukte poging niet bij dezelfde stand herhalen.
  function bepaal(mand, actie) {
    if (actie.bij === 'producten' || actie.bij === 'collectie') {
      var n = telArtikelen(mand, actie);
      return { doel: actie.perArtikel ? n : (n > 0 ? 1 : 0), sleutel: 'n' + n, rest: 0 };
    }
    var bedrag = telBedrag(mand, actie);
    return { doel: bedrag >= actie.drempel ? 1 : 0, sleutel: String(bedrag), rest: actie.drempel - bedrag };
  }

  // Bij een collectie weet alleen Shopify welke artikelen erin zitten. De sectie
  // rekent dat uit voor de mand van dit moment; die halen we vers op.
  function verversCollecties() {
    var metCollectie = ACTIES.filter(function (a) { return a.bij === 'collectie' && a.sectieId; });
    if (!metCollectie.length) return Promise.resolve();

    return fetch('/?section_id=' + encodeURIComponent(metCollectie[0].sectieId), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doos = document.createElement('div');
        doos.innerHTML = html;
        var el = doos.querySelector('[data-pp-kortingsacties]');
        if (!el) return;
        var vers = JSON.parse(el.textContent);
        ACTIES.forEach(function (a) {
          if (a.bij !== 'collectie') return;
          vers.forEach(function (v) { if (v.id === a.id) a.productIds = v.productIds || []; });
        });
      })
      .catch(function () {});
  }

  /* ---------- de ronde ---------- */

  function sync() {
    if (bezig) { wachtrij = true; return Promise.resolve(); }
    bezig = true;

    var gewijzigd = false;
    var keten = verversCollecties();
    ACTIES.forEach(function (actie) {
      keten = keten
        .then(function () { return ronde(actie); })
        .then(function (w) { if (w) gewijzigd = true; });
    });

    return keten
      .then(function () { return gewijzigd ? verversDrawer() : null; })
      .catch(function () {})
      .then(function () {
        toonMeldingen();
        bezig = false;
        if (wachtrij) { wachtrij = false; return sync(); }
      });
  }

  // Geeft true terug als de mand is aangepast.
  function ronde(actie) {
    return haalMand().then(function (mand) {
      var regels = cadeauRegels(mand, actie);
      var aantal = aantalIn(regels);
      var gratis = gratisIn(regels);
      var b = bepaal(mand, actie);
      var geheugen = herinner(actie);
      var stand = laatsteStand[actie.id] = { rest: b.rest, behaald: false, leeg: !mand.item_count };

      if (b.doel === 0) {
        onthoud(actie, '');
        if (!aantal) return false;
        return bouwAf(actie, 0, 0).then(function () { return true; });
      }

      // Er ligt een cadeau in dat niet (meer) gratis is: dat deel gaat eruit.
      if (aantal > gratis) {
        onthoud(actie, 'blok:' + b.sleutel);
        stand.behaald = gratis > 0;
        return bouwAf(actie, gratis, 0).then(function () { return true; });
      }

      if (aantal > b.doel) {
        stand.behaald = true;
        return bouwAf(actie, b.doel, 0).then(function () { return true; });
      }

      if (aantal === b.doel) {
        onthoud(actie, 'in');
        stand.behaald = true;
        return false;
      }

      // Er horen er meer in te liggen dan er nu liggen.
      if (aantal === 0) {
        if (geheugen === 'in') { onthoud(actie, 'nee'); return false; }   // klant haalde het weg
        if (geheugen === 'nee') return false;
      } else {
        stand.behaald = true;
      }
      if (geheugen === 'blok:' + b.sleutel) return false;                 // al vergeefs geprobeerd
      if (!actie.leverbaar) return false;

      return voegCadeauToe(actie, b.doel - aantal)
        .then(function () { return controleer(actie, b.sleutel); })
        .then(function () { return true; });
    });
  }

  // Na toevoegen: ligt het erin en is het echt gratis? Wat niet gratis werd gaat
  // er weer uit, en we onthouden bij welke stand, zodat we niet bij elke klik
  // opnieuw proberen.
  function controleer(actie, sleutel) {
    return haalMand().then(function (mand) {
      var regels = cadeauRegels(mand, actie);
      var stand = laatsteStand[actie.id];

      if (!regels.length) { onthoud(actie, 'blok:' + sleutel); return; }   // voorraad op

      var gratis = gratisIn(regels);
      stand.behaald = gratis > 0;

      if (gratis === aantalIn(regels)) { onthoud(actie, 'in'); return; }

      onthoud(actie, 'blok:' + sleutel);
      return bouwAf(actie, gratis, 0);
    });
  }

  // Stap voor stap afbouwen met telkens een verse mand: Shopify kan regels
  // tussendoor herschikken, waardoor oude regelsleutels niet meer kloppen.
  function bouwAf(actie, doel, pogingen) {
    if (pogingen > 8) return Promise.resolve();

    return haalMand().then(function (mand) {
      var regels = cadeauRegels(mand, actie);
      var huidig = aantalIn(regels);
      if (!regels.length || huidig <= doel) return;

      // Eerst de regel die niet gratis is, zodat de gratis overblijft.
      regels.sort(function (a, b) { return b.final_line_price - a.final_line_price; });
      var regel = regels[0];
      var eraf = Math.min(huidig - doel, regel.quantity);

      return zetAantal(regel.key, regel.quantity - eraf).then(function () {
        return bouwAf(actie, doel, pogingen + 1);
      });
    });
  }

  /* ---------- melding in de winkelmand ---------- */

  function toonMeldingen() {
    var teksten = [];
    ACTIES.forEach(function (actie) {
      var stand = laatsteStand[actie.id];
      if (!actie.toonMelding || !stand || stand.leeg) return;

      if (stand.behaald) {
        if (actie.tekstBehaald) teksten.push(veilig(actie.tekstBehaald));
      } else if (actie.bij === 'bedrag' && stand.rest > 0 && actie.leverbaar && actie.tekstOnderweg) {
        teksten.push(veilig(actie.tekstOnderweg).replace('[bedrag]', '<strong>' + euro(stand.rest) + '</strong>'));
      }
    });

    var html = teksten.join('<br>');

    // Eigen regel direct onder de meter voor gratis verzending, in dezelfde stijl.
    document.querySelectorAll('[data-items-holder]').forEach(function (holder) {
      var balk = holder.parentNode.querySelector(':scope > [data-pp-ka-melding]');
      if (!balk) {
        if (!html) return;
        balk = document.createElement('p');
        balk.className = 'cart-message cart-message--drawer pp-ka-melding';
        balk.setAttribute('data-pp-ka-melding', '');
        holder.parentNode.insertBefore(balk, holder);
      }
      if (balk.innerHTML !== html) balk.innerHTML = html;
      balk.style.display = html ? '' : 'none';
    });
  }

  function veilig(tekst) {
    var el = document.createElement('span');
    el.textContent = tekst;
    return el.innerHTML;
  }

  function euro(centen) {
    try {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(centen / 100);
    } catch (e) {
      return '€ ' + (centen / 100).toFixed(2).replace('.', ',');
    }
  }

  /* ---------- winkelmandlade bijwerken ---------- */

  function verversDrawer() {
    document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));

    return fetch('/cart?section_id=api-cart-items', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doos = document.createElement('div');
        doos.innerHTML = html;

        vervang(doos, '[data-api-line-items]', '[data-items-holder]');
        vervang(doos, '[data-api-upsell-items]', '[data-pair-products-holder]');
        vervang(doos, '[data-api-cart-price]', '[data-cart-price-holder]');
        herstelThema();

        return haalMand().then(function (mand) {
          var holder = document.querySelector('[data-items-holder]');
          if (holder) holder.classList.toggle('hidden', mand.item_count === 0);

          document.querySelectorAll('[data-cart-items-qty]').forEach(function (el) {
            el.classList.toggle('hidden', mand.item_count === 0);
            el.textContent = mand.item_count === 1 ? '1 artikel' : mand.item_count + ' artikelen';
          });

          document.querySelectorAll('[data-cart-total-price]').forEach(function (el) {
            el.textContent = euro(mand.total_price);
          });

          document.dispatchEvent(new CustomEvent('theme:cart:loaded', { bubbles: true }));
        });
      })
      .catch(function () {});
  }

  // Na het vervangen van de inhoud zijn de knoppen en de upsell-carousel van het
  // thema hun werking kwijt (ze hingen aan de oude elementen). Het thema bouwt ze
  // hiermee opnieuw op; zonder dit staan de upsells onder elkaar i.p.v. in een
  // carousel. getCart() van het thema gebruiken we bewust niet: dat klapt de
  // winkelmand open, ook als de klant daar niet om vroeg.
  function herstelThema() {
    var c = window.cart;
    if (!c || !document.querySelector('[data-items-holder]')) return;
    try {
      if (typeof c.cartEvents === 'function') c.cartEvents();
      if (typeof c.initQuantity === 'function') c.initQuantity();
      if (typeof c.renderPairProducts === 'function') c.renderPairProducts();
    } catch (e) {}
  }

  function vervang(bron, vanSel, naarSel) {
    var nieuw = bron.querySelector(vanSel);
    var doel = document.querySelector(naarSel);
    if (nieuw && doel) doel.innerHTML = nieuw.innerHTML;
  }

  /* ---------- aanhaken ---------- */

  ['theme:cart:added', 'theme:cart:update', 'theme:cart:loaded'].forEach(function (evt) {
    document.addEventListener(evt, function () { if (!bezig) setTimeout(sync, 250); });
  });

  // De lade wordt pas bij openen opgebouwd en bij elke wijziging ververst; dan
  // moet de melding er alsnog (weer) in.
  function bewaakLade() {
    var lade = document.getElementById('cart-drawer');
    if (!lade || !window.MutationObserver) return;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(toonMeldingen, 60);
    }).observe(lade, { childList: true, subtree: true });
  }

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function wikkelFetch() {
    var huidig = window.fetch;
    if (!huidig || huidig._ppKa) return;
    var basis = huidig;
    var nieuw = function () {
      var p = basis.apply(this, arguments);
      try {
        var a0 = arguments[0];
        var url = (a0 && a0.url) ? a0.url : a0;
        if (CART_RE.test(String(url)) && !bezig) {
          p.then(function () { setTimeout(sync, 300); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
    nieuw._ppKa = true;
    window.fetch = nieuw;
  }

  function wikkelXhr() {
    var proto = XMLHttpRequest.prototype;
    if (proto.open._ppKa) return;
    var basis = proto.open;
    var nieuw = function (method, url) {
      try {
        if (CART_RE.test(String(url))) {
          this.addEventListener('load', function () { if (!bezig) setTimeout(sync, 300); });
        }
      } catch (e) {}
      return basis.apply(this, arguments);
    };
    nieuw._ppKa = true;
    proto.open = nieuw;
  }

  wikkelFetch(); wikkelXhr();
  window.addEventListener('load', function () {
    wikkelFetch(); wikkelXhr();
    setTimeout(function () { wikkelFetch(); wikkelXhr(); }, 1500);
  });

  function start() { bewaakLade(); sync(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  function herlaad() {
    ACTIES = leesActies();
    laatsteStand = {};
    toonMeldingen();
    return sync();
  }

  ['shopify:section:load', 'shopify:section:unload', 'shopify:block:select'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(herlaad, 50); });
  });

  window.__ppKortingsacties = { sync: sync, herlaad: herlaad, versie: 'v4' };
})();
